import appearanceUtilities from "./appearance";
import typographyUtilities from "./typography";
import layoutUtilities from "./layout";
import zStack from "./zStack";

export default `
  ${appearanceUtilities}
  ${typographyUtilities}
  ${layoutUtilities}
  ${zStack}
`;
